import { anodum } from '@yola/ws-sdk';

function createCompositeItem({
  position = '50% 50%',
  placeholder = true,
  aspectRatio = '1',
  mediaGroupId = null,
  contentPosition = '50% 50%',
  contentScale = '1',
  width = null,
  src = '',
  alt = '',
  childNode = null,
} = {}) {
  const generatedItem = anodum.parseElementFromString(`
    <ws-composite-item
      position="${position}"
      aspect-ratio="${aspectRatio}"
      ${width ? `width="${width}"` : ''}
    >
      <ws-media-container
        ${placeholder ? 'placeholder' : ''}
        ${mediaGroupId ? `media-group-id="${mediaGroupId}"` : ''}
        content-position="${contentPosition}"
        content-scale="${contentScale}"
        aspect-ratio="1"
      >
        <picture>
          <img src="${src}" alt="${alt}" loading="lazy" />
        </picture>
      </ws-media-container>
    </ws-composite-item>
  `);

  if (childNode) {
    const mediaContainer = generatedItem.querySelector('ws-media-container');

    if (mediaContainer) {
      mediaContainer.replaceWith(childNode);
    }
  }

  return generatedItem;
}

export default createCompositeItem;
